import { render, staticRenderFns } from "./assessment-modal.vue?vue&type=template&id=b1d60486&"
import script from "./assessment-modal.vue?vue&type=script&lang=js&"
export * from "./assessment-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports